import type { ReactNode } from "react";
import { SessionContext, useSessionState } from "./useSession";

export default function SessionProvider({ children }: { children: ReactNode }) {
  return <SessionContext.Provider value={useSessionState()}>{children}</SessionContext.Provider>;
}
